var _ellipse, _ellipse2, _ellipse3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoXml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 50,
    viewBox: "0 0 40 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2647",
    "data-name": "Grupo 2647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1266",
    "data-name": "Caminho 1266",
    d: "M34.17,49.17H5.83a5,5,0,0,1-5-5V5.83a5,5,0,0,1,5-5H29.17l10,10V44.17A5,5,0,0,1,34.17,49.17Z",
    style: {
      fill: "#6478ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1267",
    "data-name": "Caminho 1267",
    d: "M.83,35.83H39.17v8.34a5,5,0,0,1-5,5H5.83a5,5,0,0,1-5-5Z",
    style: {
      fill: "#c2c7e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1268",
    "data-name": "Caminho 1268",
    d: "M39.17,10.83h-5a5,5,0,0,1-5-5h0v-5Z",
    style: {
      fill: "#c2c7e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1269",
    "data-name": "Caminho 1269",
    d: "M29.76.24A.87.87,0,0,0,29.17,0H5.83A5.84,5.84,0,0,0,0,5.83V44.17A5.83,5.83,0,0,0,5.83,50H34.17A5.83,5.83,0,0,0,40,44.17V10.83a.87.87,0,0,0-.24-.59ZM30,2.84,37.16,10h-3A4.17,4.17,0,0,1,30,5.83ZM5.83,1.66h22.5V5.83a5.84,5.84,0,0,0,5.84,5.83h4.16V35H1.67V5.83A4.16,4.16,0,0,1,5.83,1.67ZM34.17,48.33H5.83a4.16,4.16,0,0,1-4.16-4.17v-7.5H38.33v7.5a4.16,4.16,0,0,1-4.16,4.17Z",
    style: {
      fill: "#030405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1270",
    "data-name": "Caminho 1270",
    d: "M29.17,45h-2.5V39.17a.85.85,0,0,0-.84-.84.84.84,0,0,0-.83.84v6.66a.84.84,0,0,0,.83.84h3.34a.84.84,0,0,0,.83-.84.83.83,0,0,0-.83-.83h0Z",
    style: {
      fill: "#030405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1271",
    "data-name": "Caminho 1271",
    d: "M14.54,38.42a.84.84,0,0,0-1.12.37h0l-.92,1.85-.92-1.85a.83.83,0,0,0-1.49.75h0l1.48,3-1.48,3a.83.83,0,0,0,.37,1.12.84.84,0,0,0,1.12-.37h0l.92-1.84.92,1.84a.83.83,0,0,0,1.12.37.82.82,0,0,0,.37-1.11h0l-1.48-3,1.48-3a.83.83,0,0,0-.37-1.12Z",
    style: {
      fill: "#030405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1272",
    "data-name": "Caminho 1272",
    d: "M22.67,38.35a.85.85,0,0,0-.94.49l-1.73,4-1.73-4a.84.84,0,0,0-1.1-.44.81.81,0,0,0-.5.77v6.67a.83.83,0,0,0,1.66,0V43.23l.9,2.1a.83.83,0,0,0,1.53,0l.9-2.1v2.61a.84.84,0,0,0,.84.83.83.83,0,0,0,.83-.83V39.17a.84.84,0,0,0-.66-.82Z",
    style: {
      fill: "#030405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1273",
    "data-name": "Caminho 1273",
    d: "M12.74,26.42a.83.83,0,0,0,1.18-1.18h0L9.51,20.83l4.41-4.41a.84.84,0,0,0,0-1.18.85.85,0,0,0-1.17,0l-5,5a.85.85,0,0,0,0,1.18h0Z",
    style: {
      fill: "#030405"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1274",
    "data-name": "Caminho 1274",
    d: "M26.08,26.42a.83.83,0,0,0,1.18,0h0l5-5a.85.85,0,0,0,0-1.18h0l-5-5a.85.85,0,0,0-1.18,0,.83.83,0,0,0,0,1.18h0l4.41,4.41-4.41,4.41a.83.83,0,0,0,0,1.18Z",
    style: {
      fill: "#030405"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_45",
    "data-name": "Elipse 45",
    cx: 20.12,
    cy: 20.79,
    rx: 0.88,
    ry: 0.7
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_46",
    "data-name": "Elipse 46",
    cx: 23.29,
    cy: 20.79,
    rx: 0.88,
    ry: 0.7
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_47",
    "data-name": "Elipse 47",
    cx: 16.6,
    cy: 20.79,
    rx: 0.88,
    ry: 0.7
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoXml);
export default __webpack_public_path__ + "static/media/ico-xml.a5b3a6aa.svg";
export { ForwardRef as ReactComponent };